import { createContext, useContext, useMemo } from 'react';
export var AlgoliaClientContext = /*#__PURE__*/createContext(null);
export var AlgoliaClientProvider = AlgoliaClientContext.Provider;
export var useAlgoliaClient = function useAlgoliaClient() {
  var AlgoliaClient = useContext(AlgoliaClientContext);

  if (!AlgoliaClient) {
    throw new Error("Recipes index isn't available. Please set it via AlgoliaClientProvider component.");
  }

  return AlgoliaClient;
};
export var useRecipesIndex = function useRecipesIndex() {
  var client = useAlgoliaClient();
  return useMemo(function () {
    return createRecipesIndex(client);
  }, [client]);
};
export var createRecipesIndex = function createRecipesIndex(client) {
  var _process$env$NEXT_PUB;

  var internalClient = client;
  return internalClient.initIndex((_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME_RECIPES) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "");
};
export var useRecipesSearchIndex = function useRecipesSearchIndex() {
  var client = useAlgoliaClient();
  return useMemo(function () {
    return createRecipesSearchIndex(client);
  }, [client]);
};
export var createRecipesSearchIndex = function createRecipesSearchIndex(client) {
  var _process$env$NEXT_PUB2;

  var internalClient = client;
  return internalClient.initIndex((_process$env$NEXT_PUB2 = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME_RECIPES_SEARCH) !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : "");
};